import React from "react";

import { Tag, Badge } from "antd";

import { Link } from "react-router-dom";

import { LAYOUT_MANAGER_JOB_NEW, LAYOUT_MANAGER_JOB_SHOW } from "../../navigation";

import StatusLabel from "../../../../components/job/status/label";
import DateTimeJob from "../../../../components/job/status/datetime";

import { configureField } from "../../../../core/utils/list";

const DeliveryStatus = ({ job }) => {
    if (job.elapsed_delay_time_in_delivery) {
        if (job.delivery_on_time) {
            return <Badge status="success" text="On Time" />;
        }

        return <Badge status="error" text="Out of Time" />;
    }
    return null;
};

export const basicColumns = (props) => {
    const { toggle, loading, filters, resize, hidden } = props;

    if (loading) {
        return [];
    }

    return [
        {
            title: "ID #",
            dataIndex: "id",
            key: "id",
            fixed: "left",
            width: 140,
            // eslint-disable-next-line react/display-name
            render: (id, record) => <Link to={LAYOUT_MANAGER_JOB_SHOW(record.id)}>J-{id}</Link>,
            ...configureField("j.id", filters, resize, hidden, true, false, false, 200),
        },
        {
            title: "E-ID #",
            dataIndex: "eid",
            key: "eid",
            width: 140,
            // eslint-disable-next-line react/display-name
            ...configureField("j.eid", filters, resize, hidden, true, false, false, 200),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            ellipsis: true,
            width: 140,
            ...configureField("j.status", filters, resize, hidden, true, false, true, 140),
            // eslint-disable-next-line react/display-name
            render: (text) => <StatusLabel status={text} />,
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            width: 300,
            ellipsis: true,
            ...configureField("j.name", filters, resize, hidden, true, false, true, 300),
            // eslint-disable-next-line react/display-name
            render: (name, record) => <>{name}</>,
        },
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
            ...configureField("j.code", filters, resize, hidden, true, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (project) => {
                if (project) {
                    return <>{project} </>;
                }
            },
        },
        {
            title: "Project",
            dataIndex: "project",
            ...configureField("p.name", filters, resize, hidden, true, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (project) => {
                return <>{project?.name}</>;
            },
            //filters: props.projects
        },
        {
            title: "POS",
            dataIndex: "point_of_sale",
            ...configureField("pos.name", filters, resize, hidden, true, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (pointOfSale) => {
                return <>{pointOfSale?.name}</>;
            },
            //filters: props.pointsOfSale,
        },
        {
            title: "FINAL DDL",
            dataIndex: "client_deadline_at",
            ...configureField("j.clientDeadlineAt", filters, resize, hidden, true, false, true, 130),
            width: 130,
            // eslint-disable-next-line react/display-name
            render: (clientDeadlineAt, record) => <DateTimeJob value={clientDeadlineAt} status={record.status} />,
        },
        {
            title: "FTR",
            dataIndex: "elapsed_time_on_reception",
            ...configureField("j.elapsedTimeOnReception", filters, resize, hidden, true, false, true, 130),
            width: 130,
            render: (elapsed_time_on_reception) => <>{`${elapsed_time_on_reception} min`}</>,
        },
        {
            title: "OTD",
            dataIndex: "delivery_on_time",
            ...configureField("j.deliveryOnTime", filters, resize, hidden, true, false, true, 130),
            width: 130,
            render: (delivery_on_time, record) => <DeliveryStatus job={record} />,
        },
        {
            title: "Manager",
            dataIndex: "manager",
            ...configureField("j.manager", filters, resize, hidden, false, false, true, 200),
            // eslint-disable-next-line react/display-name
            render: (manager) => {
                return <>{manager?.name}</>;
            },
            //filters: props.pointsOfSale,
        },
    ];
};
